import * as ServiceCalendarNav from './service-calendar-nav';

export const ServiceCalendar = {
  ...ServiceCalendarNav,
  CalendarDay: 'calendar-day',
} as const;
